export const BREAKPOINT_DEFINITIONS = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1440,
};
//# sourceMappingURL=breakpoints.js.map